import { lazy } from 'react';
import { authRoles } from 'app/auth';

import CalendarLayout from './layouts/CalendarLayout';

const CalendarWeekViewPage = lazy(() => import('./use-cases/week-view'));
const CalendarAgendaViewPage = lazy(() => import('./use-cases/agenda-view'));
const CalendarOverdueViewPage = lazy(() => import('./use-cases/overdue-view'));

const CalendarConfig = {
  settings: {
    layout: {
      config: {
        topBanner: {
          display: false,
        },
        footer: {
          display: false,
        },
        healtheraHeader: {
          display: true,
          options: {
            pharmacySelector: true,
          },
        },
      },
    },
  },
  auth: authRoles.pharmacist,
  routes: [
    {
      path: 'calendar',
      element: (
        <CalendarLayout>
          <CalendarWeekViewPage />
        </CalendarLayout>
      ),
    },
    {
      path: 'calendar/agenda',
      element: (
        <CalendarLayout>
          <CalendarAgendaViewPage />
        </CalendarLayout>
      ),
    },
    {
      path: 'calendar/overdue',
      element: (
        <CalendarLayout>
          <CalendarOverdueViewPage />
        </CalendarLayout>
      ),
    },
  ],
};

export default CalendarConfig;
